import React, { Component } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../api';
import { FilePond } from 'react-filepond';
import { apiUrl } from "../../config.js"
import { AuthService } from '../../services/auth-service'
import { Button, Modal, Input, Checkbox, TextArea, Popup, Grid, Segment, Dimmer, Loader, Header, Dropdown,Form } from 'semantic-ui-react';

const authService = new AuthService();


class CaseUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            contactName:  authService.getUserData(AuthService.FIRSTNAME_KEY) + " " + authService.getUserData(AuthService.SURNAME_KEY) , 
            contactDetails:  authService.getUserData(AuthService.EMAIL_KEY), 
            clientId : authService.getUserData(AuthService.CUSTOMER_ID_KEY),
            updateDetails: '', 
            subjectLine: '', 
            contactNumber: '', 
            escalationFlag: false,
            attachments: [],
            submittingInProgress: false,
            actionType: '',
            fileList : []
        };
    }




    setOpen = (open) => {
        this.setState({ modalOpen: open });

        if (!open) {
            this.setState({ actionType: '' });
        }
    }

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
    }

    handleActionChange = (e, { value }) => {
        this.setState({ actionType: value });
        this.setOpen(true);
    }

    getEscalationNumber() {
        switch(this.state.clientId) {
            case '15592': //JLL
                return '01253 785230';
            case '4799': //Segro
            case '364823': //Segro
            case '365950': //Segro
                return '01253 785090';
            case '355200': //LandG
                return '01253 785240';
            case '143068': //Hammersons
            case '365855': //PHP Tradeco
                return '01253 785174';
            default: //Default
                return '01253 785235';
        }
    }

    handleEscalationChange = (e, { checked }) => {
        if(checked) {
            this.setState({ showEscalationMessage: true });

        }
        this.setState({ escalationFlag: checked });
    }

    handleFileChange = (e) => {
        this.setState({ attachments: [...this.state.attachments, ...e.target.files] });
    }

    notify = (message, error = false, refresh = false) => {
        if (error) {
            toast.error(message, {
                position: toast.POSITION.TOP_CENTER,
                delay: 50,
                autoClose: false
            });
        }else if (refresh){
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
               autoClose: false,
               onClose: () => {
                this.props.history.push("/");
                window.location.reload();
               }
            });
        } else {
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
               autoClose: false,
               closeOnClick: false
            });
        }
    }


    validateForm = () => {


           
        
     
        return  this.state.subjectLine.length > 0 
        && this.state.contactName.length > 0 
        && this.state.contactEmail.length > 0 
        && this.state.contactNumber.length > 0 
        && this.state.updateDetails.length > 0 




    }

    handleSubmit = () => {
        
        if(this.state.submittingInProgress)
        {
            this.notify("Submission in progress please wait", true);
        }

        this.setState({
                submittingInProgress: true,
        });
        const formData = new FormData();

        formData.append("subjectLine", this.state.subjectLine);

        formData.append("caseId", this.props.queryKey);
        formData.append("contactName", this.state.contactName);
        formData.append("contactEmail", this.state.contactEmail);
        formData.append("contactNumber", this.state.contactNumber);

        formData.append("updateDetails", this.state.updateDetails);
        formData.append("escalated", this.state.escalationFlag);
        formData.append("requestedType", this.state.actionType);
        formData.append("fileString", JSON.stringify(this.state.fileList));
        // try {
        api.postSubmitCaseUpdate(formData)
            .then(verifyRes => {


                if (verifyRes.success) {

                    this.setState({
                        open: false,
                        modalOpen:false,
                        submittingInProgress: false,
                        subjectLine:"",

                        contactName:"",
                        contactEmail: "",
                        contactNumber: "",

                        updateDetails:"",
                        escalationFlag:false,
                        actionType:"",
                        fileList:[]
                    });

                    this.notify("Your updates have been sent to the team, and a member of the team will be in touch in due course", false);

                } else {
                    this.setState({
                        open: false,
                        submittingInProgress: false
                    });
                    this.setOpen(false); // This will now also reset the actionType
                    this.notify("Error submitting - contact IT Helpdesk", true);
                }
            })
            .catch((error) => {
                this.setState({
                    open: false,
                    submittingInProgress: false
                });
                this.setOpen(false); // This will now also reset the actionType
                this.notify("Unhandled Error - contact IT Helpdesk", true);
            });
    }

    render() {
       

        return (
            <Grid.Column>
               
 <Button.Group compact floated='right'>
<Dropdown button className='icon' floating style={{ backgroundColor: 'green', color: 'white' }}
          text='Actions' defaultValue={null} closeOnChange={true} direction='down'
          value={this.state.actionType} // Control the value with state
            options={[
                { key: 'provide', value: 'Provide Update', text: 'Provide Update', style: { backgroundColor: '#FFF', color: '#000' } },

                { key: 'request', value: 'Request Update', text: 'Request Update' , style: { backgroundColor: '#FFF', color: '#000' } },
          ]}
          onChange={this.handleActionChange}
          />  </Button.Group>


                <Modal
                    open={this.state.showEscalationMessage}
                    size={'mini'}
                >
                    <Modal.Header>Escalate this request?</Modal.Header>
                    <Modal.Content>

     

                        <Modal.Description>
                            <p>
                            If this request requires an update within the next 24 hours, please call {this.getEscalationNumber()}
                               
                            </p>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='black' onClick={() => this.setState({ showEscalationMessage: false })}>Dismiss</Button>
                        
                    </Modal.Actions>
                </Modal>


                <Modal size="small"
                    onOpen={() => this.setOpen(true)}
                    open={this.state.modalOpen}
                >
                    <Modal.Header>
                        <h2>{this.state.actionType}</h2>
                    </Modal.Header>
                    <Modal.Content>
                        <Segment>
                            <Dimmer active={this.state.submittingInProgress}>
                                <Loader>Submitting...</Loader>
                            </Dimmer>
                            <Grid>
                            <Grid.Column>
                                <Header as='h2'>Your Details</Header>

                              <Form>
                              

                                <Input
                                    fluid placeholder='Name' name="contactName" value={this.state.contactName} onChange={this.handleChange} /><br />

                                <Input
                                    fluid placeholder='Contact Email' name="contactEmail" value={this.state.contactEmail} onChange={this.handleChange} /><br />

<Input
                                    fluid placeholder='Contact Number' name="contactNumber" value={this.state.contactNumber} onChange={this.handleChange} /><br />
                                <Header as='h2'>Update Details</Header>
                                <Input
                                    fluid placeholder='Subject Line' name="subjectLine" value={this.state.subjectLine} onChange={this.handleChange} /><br />
                                <TextArea
                                    fluid placeholder='Type your update here...' name="updateDetails" value={this.state.updateText} onChange={this.handleChange} /><br />

                                

                                <Checkbox  onChange={this.handleEscalationChange} label='Do you require this case to be escalated?'></Checkbox><br />
                                </Form>

                                <Grid.Column>
<br></br>
<Header as='h2'>Supporting Documents</Header>
<FilePond onupdatefiles={this.onFilesUpdated}  maxFileSize="7MB" labelMaxFileSizeExceeded="File is too Large" labelMaxFileSize="Maximum file size is {filesize}" allowMultiple={true} allowRevert={false} allowRemove={false} allowProcess={false} 
  acceptedFileTypes={[
    'image/jpeg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/msword', // .doc
    'application/pdf', // .pdf
    'text/csv', // .csv
    'image/tiff' // .tif
]}
server={{
    process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
        this.setState({ showInfoHide: true })
        const formData = new FormData();


       
        formData.append(fieldName, file, file.name);
        formData.append("client", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
        formData.append("uploadedBy", authService.getUserData(AuthService.EMAIL_KEY));
        const request = new XMLHttpRequest();

        //request.open('POST', `${apiUrl}/MeterReads/something/${authService.getUserData(AuthService.CUSTOMER_ID_KEY)}`);
        request.open('POST', `${apiUrl}/Documents/PublishPrivateDocument`);

        request.setRequestHeader(
            'Authorization', `bearer ${localStorage.getItem("token")}`);

        request.upload.onprogress = (e) => {
            try
            {
            progress(e.lengthComputable, e.loaded, e.total);
            }catch
            {
                
                error("Failed please check file size")
            }

        };

        request.onerror = (e) =>
        {
          
            error("Failed please check file size")
        }

        request.onload = (e) => {
            var obj = JSON.parse(e.srcElement.response);



            if (request.status >= 200 && request.status < 300) {

                if (obj.hasErrors) {


                    error("Failed")


                } else {


                    let myArr = [...this.state.fileList]
                     myArr.push(obj.fileId)
                    this.setState({
                        fileList: myArr
                    })

                    load("Success");
                }

            }
            else {


                error('failed upload please check the file format.');
            }
        };


        request.send(formData);

        return {

            abort: () => {
                request.abort();
                abort();
            }
        };
    }
}} />
</Grid.Column>
                            
                            </Grid.Column>
                            </Grid>
                        </Segment>
                    </Modal.Content>
                    <Modal.Actions>
                    {/* <Button onClick={this.handleSubmit}>Submit</Button> */}

{/* Conditional tooltip for the Continue button */}
{this.validateForm()
        ? <Button
            
            id='confirm-user'
            onClick={this.handleSubmit}
          >
            Submit
          </Button>
        : <Popup
            content="Please check all case details and contact details have been filled in"
            trigger={
              <span>
                <Button
                  
                  disabled
                >
                  Submit
                </Button>
              </span>
            }
          />
    }



                                <Button onClick={() => this.setOpen(false)}>Cancel</Button>
                        
                    </Modal.Actions>
                </Modal>
            </Grid.Column>
        )
    }
}

export default CaseUpdate;
